import React from "react";
import SortingMain from "./components/ArraySorting/SortingMain";

function App()
{
  return (
      <SortingMain/>
  );
}

export default App;
